import _ from 'lodash';
// eslint-disable-next-line import/no-cycle
import {
  loadProfile, loadSPProfile, loadPermissions, loadPermissionsForSP, findUserPoolId,
  findUserPoolClientId, deleteUserPoolId, findIdentityId,
} from '@/services/repository';
import { createRunMutationAction } from '@/store/utils';
import {
  CLEAR_PROJECTS,
  CLEAR_DETAILED_PROJECT,
  CLEAR_TEST_CARDS,
} from '@/store/project/actionTypes';
import { LOAD_REQUESTS, CLEAR_REQUESTS } from '@/store/request/actionTypes';
import { SET_NEW_PROJECT, SET_NEW_PROJECT_NAVIGATION } from '@/store/newProject/actionTypes';
import {
  CLEAR_USERS, CLEAR_WORKERS, LOAD_DOMAINS, CLEAR_DOMAINS, LOAD_ALL_TENANT_USERS,
  CLEAR_TENANT_USERS_LIST,
} from '@/store/user/actionTypes';
import { emptyProject, initNewProjectNavigation } from '@/constants/projects';
import * as types from '@/store/auth/actionTypes';
import config from '@/amplify/config';
import {
  SET_AUTH,
  CLEAR_AUTH,
  SET_CHALLENGE,
  CLEAR_CHALLENGE,
  SET_PROFILE,
  SET_PERMISSIONS,
  SET_LOGIN_DOMAIN,
  CLEAR_USER_POOL_ID,
  CLEAR_LOGIN_DOMAIN,
  SET_USER_POOL_ID,
  SET_PREFILL_DATA,
  CLEAR_PREFILL_DATA,
} from '@/store/auth/mutationTypes';
import { CLEAR_ISSUE_DETAILS, CLEAR_ISSUES } from '@/store/issue/actionTypes';
import { CLEAN_INVITATION_CODE_DATA, CLEAN_REGISTRATION_DATA } from '@/store/registration/actionTypes';
import { LOAD_NOTIFICATIONS } from '@/store/notification/actionTypes';
import { SET_IS_SERVICE_PROVIDER } from '@/store/user/mutationTypes';
import { CLEAR_DOMAIN_FILTER, CLEAR_ORGANIZATION_FILTER } from '@/store/filters/actionTypes';
import { CLEAR_LICENSES } from '@/store/license/actionTypes';
import { LOAD_ALL_ORGANIZATIONS } from '@/store/organization/actionTypes';
import { CLEAR_ITEMS_PER_PAGE } from '@/store/pagination/actionTypes';

export default {
  // eslint-disable-next-line no-empty-pattern
  async [types.DELETE_USER_POOL]({}, userPoolId) {
    await deleteUserPoolId(userPoolId);
  },
  async [types.FIND_USER_POOL_ID]({ commit }, domain) {
    let userPoolId = '';
    try {
      userPoolId = await findUserPoolId(domain);
      localStorage.setItem('userPoolId', userPoolId);
      const identityId = await findIdentityId({ userPoolId });
      localStorage.setItem('identityId', identityId);
      localStorage.setItem('bucketName', userPoolId?.toString().replaceAll('_', '').toLowerCase() || '');
      commit(SET_USER_POOL_ID, userPoolId);
      commit(SET_LOGIN_DOMAIN, domain);
    } catch (err) {
      console.log(err);
    }
    config.Auth.userPoolId = userPoolId;
  },
  async [types.FIND_USER_POOL_CLIENT_ID]() {
    let userPoolClientId = '';
    try {
      const options = { id: config.Auth.userPoolId };
      userPoolClientId = await findUserPoolClientId(options);
    } catch (err) {
      console.log(err);
    }
    config.Auth.userPoolWebClientId = userPoolClientId;
  },
  // eslint-disable-next-line no-unused-vars
  async [types.SET_LOGIN_DOMAIN]({ commit, getters }, domain) {
    commit(SET_LOGIN_DOMAIN, domain);
  },
  // eslint-disable-next-line no-unused-vars
  async [types.SET_AUTH]({ commit, dispatch, getters }, auth) {
    commit(SET_AUTH, auth);
    commit(CLEAR_CHALLENGE);
    try {
      let isSPFlag = false;
      if (auth['cognito:groups'].includes('SPWorker') ||
        auth['cognito:groups'].includes('SPFreelancer') ||
        auth['cognito:groups'].includes('SPAdmin')
      ) {
        commit(SET_IS_SERVICE_PROVIDER, true);
        isSPFlag = true;
      }

      let profile;
      if (isSPFlag) {
        try {
          profile = await loadSPProfile();
        } catch (e) {
          console.log(`${e}`);
        }
      } else {
        const userPoolId = auth.iss.substr(auth.iss.lastIndexOf('/') + 1);
        commit(SET_USER_POOL_ID, userPoolId);
        profile = await loadProfile();
      }
      commit(SET_PROFILE, profile);

      if (auth.email_verified) {
        let permissionsResponse;
        if (isSPFlag) {
          permissionsResponse = await loadPermissionsForSP();
        } else {
          permissionsResponse = await loadPermissions();
        }
        const permissions = permissionsResponse;
        commit(SET_PERMISSIONS, permissions.permissions);

        if (permissions.permissions.includes('company.sp')) {
          await dispatch(LOAD_REQUESTS);
        }
        if (permissions.permissions.includes('all.tenant.users')) {
          await dispatch(LOAD_ALL_TENANT_USERS);
        }
        if (permissions.permissions.includes('tenant.user.data')) {
          await dispatch(LOAD_DOMAINS);
          await dispatch(LOAD_ALL_ORGANIZATIONS);
        }
        await dispatch(LOAD_NOTIFICATIONS);
      }
    } catch (e) {
      console.log(`Error in set Auth: ${e}`);
    }
  },
  [types.CLEAR_LOGIN_DOMAIN]: createRunMutationAction(CLEAR_LOGIN_DOMAIN),
  [types.CLEAR_USER_POOL_ID]: createRunMutationAction(CLEAR_USER_POOL_ID),
  async [types.CLEAR_AUTH]({ commit, dispatch }) {
    commit(CLEAR_AUTH);
    await dispatch(CLEAR_PROJECTS);
    await dispatch(CLEAR_REQUESTS);
    await dispatch(CLEAR_DOMAINS);
    await dispatch(CLEAR_USERS);
    await dispatch(CLEAR_WORKERS);
    await dispatch(CLEAR_ISSUES);
    await dispatch(CLEAR_ISSUE_DETAILS);
    await dispatch(CLEAR_DETAILED_PROJECT);
    await dispatch(types.CLEAR_LOGIN_DOMAIN);
    await dispatch(CLEAR_TENANT_USERS_LIST);
    await dispatch(CLEAR_TEST_CARDS);
    await dispatch(CLEAN_REGISTRATION_DATA);
    await dispatch(CLEAN_INVITATION_CODE_DATA);
    await dispatch(SET_NEW_PROJECT, _.cloneDeep(emptyProject));
    await dispatch(SET_NEW_PROJECT_NAVIGATION, _.cloneDeep(initNewProjectNavigation));
    await dispatch(types.CLEAR_USER_POOL_ID);
    await dispatch(CLEAR_DOMAIN_FILTER);
    await dispatch(CLEAR_ORGANIZATION_FILTER);
    await dispatch(CLEAR_LICENSES);
    await dispatch(CLEAR_ITEMS_PER_PAGE);
  },
  [types.SET_CHALLENGE]: createRunMutationAction(SET_CHALLENGE),
  [types.CLEAR_CHALLENGE]: createRunMutationAction(CLEAR_CHALLENGE),
  [types.SET_PREFILL_DATA]: createRunMutationAction(SET_PREFILL_DATA),
  [types.CLEAR_PREFILL_DATA]: createRunMutationAction(CLEAR_PREFILL_DATA),
};
